// export const API_URL = "http://localhost:8000";
export const API_URL = "https://api.lebanononlinemall.com";
export const API_URL_IMAGE_CATEGORY = API_URL + "/images/categories/";
export const API_URL_IMAGE_SHOP = API_URL + "/images/shops/";
export const API_URL_IMAGE_ITEM = API_URL + "/images/items/";
